<template>
<div id="fiberglass" class="w-100 tc black pb4">
    <div class="container w-100">
      
      <div class="relative dt w-100" :style="{ 'height': mobile ? '45vh': '80vh'}">
        <div class="w-100 b ph2-ns tc">
          <!-- <div class="f1 ps-blue">Industry Leading Insulation Equipment</div> -->
          <img v-if="!mobile" class="" src="../assets/Website-Banners/15.png" />
          <div v-if="mobile">
              <img class="w-100" src="../assets/Website-Banners/mach1.png"/>
              <img class="w-100" src="../assets/Website-Banners/mach2.png"/>
          </div>
        </div>
      </div>
      

      <div class="dt w-90-ns center ">
        <div class="w-50-ns w-100 pt4-ns pt2 pic-container" :class="[mobile ? 'dib' : 'dtc v-mid']">
          <!-- <div class="pa3"><img class="applegate" src="../assets/logos-color/krendel.png"/></div> -->
          <div class="pa3"><img class="insul" src="../assets/intecmachine.png"/></div>
          <!-- <div class="pa3"><img class="sustainable" src="../assets/logos-color/Intec-Logo-Blue.jpg"/></div> -->
        </div>

        <div class="pt4" :class="[mobile ? 'w-90 dib' : 'w-50 lh-copy f4 dtc v-mid']">
          <div class="tl t4 bullets">
            <h3 @click="expand1 = !expand1"><span class="mt2 f3" v-if="!expand1">+</span><span v-else class="mt2 f3">-</span>INSULATION BLOWER MACHINE</h3>
            <transition name="fade">
              <div v-if="expand1" class="">These machines provide the highest class in performance and efficiency for blow-in insulation applications.</div>
            </transition>
            <h3 @click="expand2 = !expand2"><span class="mt2 f3" v-if="!expand2">+</span><span v-else class="mt2 f3">-</span>VACUUM INSULATION MACHINE</h3>
              <div v-if="expand2" class="">We carry all options from truck and trailer rig equipment in air, electric and hydraulic versions to reusable and single-use equipment for all your spray foam needs.</div>

            <h3 @click="expand3 = !expand3"><span class="mt2 f3" v-if="!expand3">+</span><span v-else class="mt2 f3">-</span>MACHINE ACCESSORIES</h3>
              <div v-if="expand3" class="">We offer a variety of vacuum and blown-in insulation machine accessories, hoses, and safety gear from the leading brands you trust.</div>
          </div>
        </div>
      </div>

      
      <div class="w-20-ns tc w-70 mt4-ns mt2 center">
        <div class="f3-ns f4 pa1">
            <a class="link" :href="info.tel">
              <div class="contact-button ps-blue b br3 bg-yellow tc pa2 link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
          </a> 
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Cellulose',
  props: ['info', 'mobile'],
  data() {
    return {
      expand1: false,
      expand2: false,
      expand3: false,
    };
  },
  methods: {
  },
  components: { 
  }
};
</script>

<style scoped>
.moreless {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}
.spec {
  border: black 1px solid;
  padding: .5rem;
  margin: 0.5rem .5rem;
  border-radius: 2%;
}
.spec:hover{
  background: rgb(15,55,111);
  color: white;
}
.spec:hover img {
    -webkit-filter: invert(1);
}
h3 {
  padding: 1rem;
  border: solid black 1px;
  background: rgb(15,55,111);
  text-align: center;
  color: white;
}
#fiberglass {
  min-height: 85vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
  /* background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7)), url("https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg");
  background-repeat: no-repeat;
  background-size: cover; */
}
.relative {
  /* background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .5)), url("../assets/Website-Banners/15.png"); */
  /* background-repeat: no-repeat;
  background-size: cover;  */
  background-position: 50% 10%;
}
.banner {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7));
  max-height: 300px;
}
.absolute {
  top: 10%;
  right: 10%;
}
.applegate {
  max-height: 100px;
}
.sustainable {
  max-height: 100px;
}
.insul {
  max-height: 550px;
}
.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: .7rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
.link {
  /* box-shadow: rgb(15,55,111) 3px 3px !important; */
  text-decoration: none;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>